import { suggestionRdService, upload } from "../../services";
import { updateDate } from "../../helpers";
import store from "../store";
export const suggestionRD = {
  namespaced: true,
  state: {
    pagedData: [],
    totalRecords: null,
    pageIndex: 0,
    departmentsData: [],
    sectionsData: [],
    unitsData: [],
    pagedIdData: [],
    continuityTrackingRdList: [],
    contTrackingTotalRecords: null,
    trainingProjects: [],
  },
  getters: {
    pageData(state) {
      return state.pagedData;
    },
    totalRecords(state) {
      return state.totalRecords;
    },
    pageIndex(state) {
      return state.pageIndex;
    },
    departmentsData(state) {
      return state.departmentsData;
    },
    sectionsData(state) {
      return state.sectionsData;
    },
    unitsData(state) {
      return state.unitsData;
    },
    pagedIdData(state) {
      return state.pagedIdData;
    },
    getContinuityTrackingList(state) {
      return state.continuityTrackingRdList;
    },
    getContTrackingTotalRecords(state) {
      return state.contTrackingTotalRecords;
    },
    getTrainingProjects(state) {
      return state.trainingProjects;
    },
  },
  mutations: {
    async SET_DATA(state, payload) {
      for await (const element of payload) {
        if (element.UserPictureId != 0) {
          const res = await upload.fetchProfileImage(
            parseInt(element.UserPictureId)
          );
          if (res.Data.DownloadBinary) {
            element.UserProfileImage = res.Data.DownloadBinary;
          } else {
            element.UserProfileImage = null;
          }
        } else {
          element.UserProfileImage = null;
        }

        element.CreatedOnUtc = updateDate(element.CreatedOnUtc);
        element.ModifiedDateUtc = updateDate(element.ModifiedDateUtc);
        element.PendingProcessDate = updateDate(element.PendingProcessDate);
        element.ProjectStartDate = updateDate(element.ProjectStartDate);
        element.SuggestionDate = updateDate(element.SuggestionDate);
        element.SuggestionExecutiveProcessDate = updateDate(
          element.SuggestionExecutiveProcessDate
        );

        for await (const comment of element.Comments) {
          comment.CreatedOnUtc = updateDate(comment.CreatedOnUtc);
          if (comment.UserPictureId != 0) {
            const res = await upload.fetchProfileImage(
              parseInt(comment.UserPictureId)
            );
            if (res.Data.DownloadBinary) {
              comment.UserProfileImage = res.Data.DownloadBinary;
            } else {
              comment.UserProfileImage = null;
            }
          } else {
            comment.UserProfileImage = null;
          }
        }
        for await (const item of element.Likes) {
          if (item.UserPictureId != 0) {
            const res = await upload.fetchProfileImage(
              parseInt(item.UserPictureId)
            );
            if (res.Data.DownloadBinary) {
              item.UserProfileImage = res.Data.DownloadBinary;
            } else {
              item.UserProfileImage = null;
            }
          } else {
            item.UserProfileImage = null;
          }
          if (item.UserId == store.getters["user/user"].Data.UserId) {
            element.IsLiked = true;
          } else {
            element.IsLiked = false;
          }
        }
      }

      state.pagedData.push(...payload);
    },
    SET_TOTAL_RECORDS(state, payload) {
      state.totalRecords = payload;
    },
    SET_PAGE_INDEX(state) {
      state.pageIndex++;
    },
    DELETE_DATA(state) {
      state.pagedData = [];
      state.pageIndex = 0;
    },
    GET_DEPARTMENTS_DATA(state, payload) {
      state.departmentsData = payload;
    },
    GET_SECTIONS_DATA(state, payload) {
      state.sectionsData = payload;
    },
    GET_UNITS_DATA(state, payload) {
      state.unitsData = payload;
    },
    async SET_CONTINUITYTRACKINGRD_DATA(state, payload) {
      state.continuityTrackingRdList = payload;
    },
    SET_CONTINUITYTRACKINGRD_DATA_TOTAL_RECORDS(state, payload) {
      state.contTrackingTotalRecords = payload;
    },
    DELETE_CONTINUITYTRACKING_DATA(state) {
      state.continuityTrackingRdList = [];
    },
    async SET_ID_DATA(state, payload) {
      for await (const element of [payload]) {
        if (element.UserPictureId != 0) {
          const res = await upload.fetchProfileImage(
            parseInt(element.UserPictureId)
          );
          if (res.Data.DownloadBinary) {
            element.UserProfileImage = res.Data.DownloadBinary;
          } else {
            element.UserProfileImage = null;
          }
        } else {
          element.UserProfileImage = null;
        }
        element.CreatedOnUtc = updateDate(element.CreatedOnUtc);
        element.ModifiedDateUtc = updateDate(element.ModifiedDateUtc);
        element.PendingProcessDate = updateDate(element.PendingProcessDate);
        element.ProjectStartDate = updateDate(element.ProjectStartDate);
        element.SuggestionDate = updateDate(element.SuggestionDate);
        element.SuggestionExecutiveProcessDate = updateDate(
          element.SuggestionExecutiveProcessDate
        );
        for await (const comment of element.Comments) {
          comment.CreatedOnUtc = updateDate(comment.CreatedOnUtc);
          if (comment.UserPictureId != 0) {
            const res = await upload.fetchProfileImage(
              parseInt(comment.UserPictureId)
            );
            if (res.Data.DownloadBinary) {
              comment.UserProfileImage = res.Data.DownloadBinary;
            } else {
              comment.UserProfileImage = null;
            }
          } else {
            comment.UserProfileImage = null;
          }
        }
        for await (const item of element.Likes) {
          if (item.UserPictureId != 0) {
            const res = await upload.fetchProfileImage(
              parseInt(item.UserPictureId)
            );
            if (res.Data.DownloadBinary) {
              item.UserProfileImage = res.Data.DownloadBinary;
            } else {
              item.UserProfileImage = null;
            }
          } else {
            item.UserProfileImage = null;
          }
          if (item.UserId == store.getters["user/user"].Data.UserId) {
            element.IsLiked = true;
          } else {
            element.IsLiked = false;
          }
        }
      }

      state.pagedIdData.push(payload);
    },
    async SET_TRAINING_PROJECTS(state, payload) {
      state.trainingProjects = payload;
    },
  },
  actions: {
    async setData(vuexContext) {
      const pageSize = 5;
      const body = {
        Page: suggestionRD.state.pageIndex,
        PageSize: pageSize,
        LoginUserId: store.getters["user/user"].Data.UserId,
        IsAssignment: false,
      };
      const res = await suggestionRdService.fetchPagedSuggesitonRD(body);
      res.Data && vuexContext.commit("DELETE_DATA");
      res.Data && vuexContext.commit("SET_DATA", res.Data.Data);
      res.Data &&
        vuexContext.commit("SET_TOTAL_RECORDS", res.Data.TotalRecords);
    },
    setPageIndex(vuexContext) {
      vuexContext.commit("SET_PAGE_INDEX");
    },
    deletePagedData(vuexContext) {
      vuexContext.commit("DELETE_DATA");
    },
    async getDepartments(vuexContext, filterOnlyExist) {
      const companyId = store.getters["user/user"].Data.CompanyId;
      const companyGroupId = store.getters["user/user"].Data.CompanyGroupId;
      const res = await suggestionRdService.fetchGetDepartments(
        companyId,
        companyGroupId,
        filterOnlyExist
      );
      vuexContext.commit("GET_DEPARTMENTS_DATA", res.Data);
    },
    async getSections(vuexContext, filterOnlyExist) {
      const companyId = store.getters["user/user"].Data.CompanyId;
      const companyGroupId = store.getters["user/user"].Data.CompanyGroupId;
      const res = await suggestionRdService.fetchGetSections(
        companyId,
        companyGroupId,
        filterOnlyExist
      );
      vuexContext.commit("GET_SECTIONS_DATA", res.Data);
    },
    async getUnits(vuexContext, filterOnlyExist) {
      const companyId = store.getters["user/user"].Data.CompanyId;
      const companyGroupId = store.getters["user/user"].Data.CompanyGroupId;
      const res = await suggestionRdService.fetchGetUnits(
        companyId,
        companyGroupId,
        filterOnlyExist
      );
      vuexContext.commit("GET_UNITS_DATA", res.Data);
    },    
    async setIdData(vuexContext, data) {
      const res = await suggestionRdService.fetchGetByIdSuggestion(data);
      vuexContext.commit("SET_ID_DATA", res.Data);
    },
    async setContinuityTrackingBulkData(vuexContext, data) {
      const {
        pageSize,
        pageIndex,
        loginUserId,
        isAdminPage,
        onlyContinuityTrackingSuggestion
      } = data;
      const body = {
        Page: pageIndex,
        PageSize: pageSize,
        LoginUserId: loginUserId,
        IsAdminPage: isAdminPage,
        OnlyContinuityTrackingSuggestion: onlyContinuityTrackingSuggestion
      };
      const res = await suggestionRdService.fetchGetContinuityTrackingSuggestionRdList(body);
      res.Data && vuexContext.commit("DELETE_CONTINUITYTRACKING_DATA");
      res.Data && vuexContext.commit("SET_CONTINUITYTRACKINGRD_DATA", res.Data.Data);
      res.Data &&
        vuexContext.commit(
          "SET_CONTINUITYTRACKINGRD_DATA_TOTAL_RECORDS",
          res.Data.TotalRecords
        );
    },
    deleteContinuityTrackingBulkData(vuexContext) {
      vuexContext.commit("DELETE_CONTINUITYTRACKING_DATA");
    },
    async getTrainingProjects(vuexContext) {
      const companyId = store.getters["user/user"].Data.CompanyId;
      const companyGroupId = store.getters["user/user"].Data.CompanyGroupId;
      const res = await suggestionRdService.fetchGetTrainingProjects(
        companyId,
        companyGroupId
      );
      vuexContext.commit("SET_TRAINING_PROJECTS", res.Data);
    },
  },
};
